/**
 * Issues without a cover still need to look like something. A stable hash of
 * the title picks two hues, so the same series always gets the same colours.
 */
export function coverGradient(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(index);
    hash |= 0;
  }

  const hue = Math.abs(hash) % 360;
  const secondHue = (hue + 48) % 360;

  return `linear-gradient(140deg, oklch(0.42 0.14 ${hue}), oklch(0.22 0.09 ${secondHue}))`;
}
